import React, { useState, useEffect } from 'react'
import { Switch } from 'antd'
import { useFetchData } from '@ant-design/pro-utils';

/**
 * 根据异步回调状态回显的switch
 * @param {obj} props:
 * checked:初次加载是否选中
 * handleClick:点击后的回调函数，返回promise对象，且resolve或reject的参数是{boolean} checked
 */
export default function AsyncSwitch(props) {
    const [loading, setLoading] = useState(false);
    const [checked, setChecked] = useState(props.checked);

    useEffect(() => {
        setTimeout(() => {
            setChecked(props.checked);
        }, 0);
    }, [props])


    function handleClick(checked) {
        // console.log('AsyncSwitch handleClick checked:', checked);
        setLoading(true);
        props.handleClick(checked).then(checked => {
            // console.log('AsyncSwitch resolve checked:', checked);
            setChecked(checked);
            setLoading(false);
        }).catch(
            checked => {
                setChecked(checked);
                setLoading(false);
                // console.log('AsyncSwitch reject checked:', checked);
            }
        )
    }
    return <Switch checked={checked} loading={loading} onClick={(checked) => { handleClick(checked) }} />
    // return (<div >{checked + '-'}<Switch checked={checked} loading={loading} onClick={(checked) => { handleClick(checked) }} />{'+' + props.checked}
    //     <div>{clicked ? clicked : null}</div>
    // </div>)

}